import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-empty-content',
  templateUrl: './empty-content.component.html',
  styleUrls: ['./empty-content.component.css']
})
export class EmptyContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/empty/empty-content/empty-content.component.ts